import { cva } from 'class-variance-authority';

/**
 * Styles for ForgotEmailPage component
 */
export const forgotEmailPageStyles = cva(
  [
    'min-h-screen',
    'flex',
    'flex-col',
    'w-full', // Ensure 100% width
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

export const forgotEmailPageMainStyles = cva(
  [
    'flex',
    'w-full', // Ensure 100% width
  ],
  {
    variants: {
      device: {
        mobile: ['items-start', 'justify-start'],
        tablet: ['items-center', 'justify-center'],
        desktop: ['items-center', 'justify-start'], // Center horizontally, start from top vertically
      },
    },
    defaultVariants: {},
  }
);
